export default __webpack_public_path__ + "static/media/icon--twitter.9fe915ab.svg";